import { render, staticRenderFns } from "./AuthorizedRequestsView.vue?vue&type=template&id=7b61d1ea&scoped=true"
import script from "./AuthorizedRequestsView.vue?vue&type=script&lang=js"
export * from "./AuthorizedRequestsView.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedRequestsView.vue?vue&type=style&index=0&id=7b61d1ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b61d1ea",
  null
  
)

export default component.exports